import React, { useState, useEffect } from "react";
import {
  Avatar,
  Typography,
  Box,
  TextField,
  IconButton,
  CircularProgress,
  Tooltip,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Check, Close } from "@material-ui/icons";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  ticketInfoContainer: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1),
  },
  contactAvatar: {
    marginRight: theme.spacing(2),
    cursor: "pointer",
  },
  textContent: {
    flex: 1,
    minWidth: 0,
    cursor: "pointer",
  },
  title: {
    fontWeight: "bold",
  },
  titleEditor: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  placeholder: {
    fontStyle: "italic",
    color: theme.palette.text.secondary,
  },
  contactName: {
    color: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.95)" : "rgba(0, 0, 0, 0.8)",
    fontWeight: 'bold',
  },
}));

const TicketInfo = ({ contact, ticket, onAvatarClick, onTicketTitleUpdate }) => {
  const classes = useStyles();
  const [isEditing, setIsEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [editableTitle, setEditableTitle] = useState("");
  
  useEffect(() => {
    setEditableTitle(ticket.title || "");
  }, [ticket.title]);

  const handleStartEditing = () => {
    setIsEditing(true);
  };

  const handleCancelEditing = () => {
    setIsEditing(false);
    setEditableTitle(ticket.title || "");
  };

  const handleSaveTitle = async (e) => {
    e.preventDefault();
    const newTitle = editableTitle.trim();
    if (newTitle === (ticket.title || "").trim()) {
      setIsEditing(false);
      return;
    }
    setSaving(true);

    try {
      await api.put(`/tickets/${ticket.id}`, { title: newTitle });

      setIsEditing(false); 

      if (onTicketTitleUpdate) {
          onTicketTitleUpdate(newTitle); 
      }
      toast.success("Descripción del ticket actualizada correctamente");
    } catch (err) {
      toastError(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={classes.ticketInfoContainer}>
      <Tooltip title="Ver/Editar Contacto" placement="top">
        <Avatar
          src={contact.profilePicUrl}
          alt="contact_image"
          className={classes.contactAvatar}
          onClick={onAvatarClick}
        />
      </Tooltip>

      {isEditing ? (
        <form onSubmit={handleSaveTitle} className={classes.titleEditor}>
          <TextField
            value={editableTitle}
            onChange={(e) => setEditableTitle(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Escape") handleCancelEditing();
            }}
            variant="outlined"
            size="small"
            fullWidth
            autoFocus
            disabled={saving}
          />
          <IconButton type="submit" color="primary" size="small" disabled={saving}>
            {saving ? <CircularProgress size={20} /> : <Check />}
          </IconButton>
          <IconButton color="secondary" size="small" onClick={handleCancelEditing} disabled={saving}>
            <Close />
          </IconButton>
        </form>
      ) : (
        <Box className={classes.textContent} onClick={handleStartEditing}>
          <Tooltip title="Click para editar la descripción del ticket" placement="top">
            <Typography noWrap className={classes.title}>
              {ticket.title ? (
                ticket.title
              ) : (
                <span className={classes.placeholder}>Añadir descripción...</span>
              )}
            </Typography>
          </Tooltip>
          <Typography noWrap variant="body2" color="textSecondary">
            <span className={classes.contactName}>{contact.name}{" #" + ticket.id}</span>
            {ticket.user && " | " + i18n.t("messagesList.header.assignedTo") + " " + ticket.user.name}
          </Typography>
        </Box>
      )}
    </div>
  );
};

export default TicketInfo;